import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { eAuth0ClientType } from '../types/eAuth0ClientType';

export const getAuth0ClientTypeFromUserType = (userType: eAccessControlUserType): eAuth0ClientType => {
  switch (userType) {
    case eAccessControlUserType.Admin:
      return eAuth0ClientType.AdminNew;
    case eAccessControlUserType.Client:
      return eAuth0ClientType.Client;
    case eAccessControlUserType.Vendor:
      return eAuth0ClientType.Vendor;
  }
  throw new Error(`Client Type not found for userTyoe ${userType}`);
};
